import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { atom } from 'jotai';
import { createContext } from 'react';

import type { TradeMode } from '@flipster/r230522/model/prex.v2.r230522.tables.private_account';
import { accountBunja } from '@flipster/r230522/normal-sub/tables/private/account';

export type { TradeMode } from '@flipster/r230522/model/prex.v2.r230522.tables.private_account';

export const TradeModeContext = createContext<TradeMode | undefined>(undefined);
export const TradeModeScope = createScopeFromContext(TradeModeContext);

export const tradeModeBunja = bunja(() => {
  const override = bunja.use(TradeModeScope);
  const { accountAtom } = bunja.use(accountBunja);
  const tradeModeAtom = atom((get) => override ?? get(accountAtom)?.tradeMode);
  return { tradeModeAtom };
});
tradeModeBunja.debugLabel = 'tradeModeBunja';
